<template>
  <v-card class="base-delete-modal">
    <div class="base-delete-modal__header">
      <div class="base-delete-modal__title-wrap">
        <v-icon v-if="showWarningIcon" class="base-delete-modal__icon" color="error">mdi-alert-outline</v-icon>
        <v-card-title class="base-delete-modal__title">{{ messageTitle }}</v-card-title>
      </div>
    </div>
    <v-card-text class="base-delete-modal__text">{{ messageText }}</v-card-text>
    <v-card-actions class="base-delete-modal__actions">
      <v-spacer />
      <v-btn
        color="primary"
        outlined
        class="text-none"
        rounded
        @click="close"
      >
        <v-icon left small>mdi-close</v-icon>
        {{ cancelText }}
      </v-btn>
      <v-btn
        :color="confirmColor"
        class="text-none"
        dark
        rounded
        @click="submit"
      >
        <v-icon left small>{{ confirmIcon }}</v-icon>
        {{ confirmText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    messageTitle: {
      type: String,
      required: true,
    },
    messageText: {
      type: String,
      required: true,
    },
    confirmText: {
      type: String,
      default: 'Применить',
    },
    cancelText: {
      type: String,
      default: 'Отмена',
    },
    confirmColor: {
      type: String,
      default: 'primary',
    },
    showWarningIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    confirmIcon () {
      return this.confirmColor === 'error' ? 'mdi-delete-outline' : 'mdi-check';
    },
  },
  methods: {
    async submit () {
      await this.$emit('submit');
      this.$emit('update:active', false);
    },
    async close () {
      await this.$emit('close');
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-delete-modal {
  border-radius: 12px;
  overflow: hidden;
}

.base-delete-modal__header {
  padding: 20px 24px 0;
}

.base-delete-modal__title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.base-delete-modal__icon {
  flex-shrink: 0;
}

.base-delete-modal__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  padding: 0;
  letter-spacing: -0.01em;
}

.base-delete-modal__text {
  font-size: 0.9375rem;
  color: #546e7a;
  padding: 16px 24px 8px;
  line-height: 1.5;
}

.base-delete-modal__actions {
  padding: 8px 24px 20px;
  gap: 12px;
}
</style>
